// src/functions/getRuntimeSession.js
// Loads full session config (settings + activities + content) for runtime.
// Works for both presenter (admin token) and participant (session token).

export async function getRuntimeSession({ token, currentTheme }) {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/pp2/getRuntimeSession`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ currentTheme }),
  });
  const json = await res.json();
  if (!res.ok || !json.success) {
    throw new Error(json.message || "Failed to load runtime session");
  }
  return json.data; // { themename, settings, activities[] }
}

export default getRuntimeSession;
